/**
 * Observes when document.title is updated (useful with vue-meta)
 * @param {Function} callback
 */
export function waitForTitleUpdate(callback) {
  const titleElement = document.querySelector("title");

  if (!titleElement) {
    callback(document.title);

    return;
  }

  const observer = new MutationObserver(() => {
    observer.disconnect();
    callback(document.title);
  });

  observer.observe(titleElement, { childList: true });
}

/**
 * Push VirtualPageview to dataLayer
 * @param {Object} user
 * @param {string} locale
 * @param {string} pageTitle
 * @param {string} serviceCenterCategory
 */

import en from "../i18n/en.json";
import fr from "../i18n/fr.json";

export function trackPageView({
  user,
  locale,
  pageTitle,
  serviceCenterCategory,
  pathname = window.location.pathname
}) {
  if (!window.dataLayer) {
    return;
  }

  const translationsSource = locale === "fr" ? fr : en;

  const matchingKey = Object.keys(translationsSource).find(
    key => key.endsWith("_url") && translationsSource[key] === pathname
  );

  const pageNameKey = matchingKey?.replace("_url", "");
  const pageName = en[pageNameKey] || null;
  const clientCategory = serviceCenterCategory;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "VirtualPageview",
    user_type: user ? "client" : "guest",
    client_type: user?.userIDTypeValue || null,
    client_category: clientCategory,
    client_id: user?.customerID || null,
    page_language: locale,
    page_location: window.location.pathname,
    page_title: pageTitle,
    page_name: pageName
  });
}
